import { useLocation } from 'react-router-dom'

export const LOCATION_CHANGE = 'router/LOCATION_CHANGE'

export type Location = ReturnType<typeof useLocation>
